import React from 'react';
import PrimaryHeading from "../../components/PrimaryHeading/PrimaryHeading";
import HeadingGradient from "../../components/HeadingGradient/HeadingGradient";
import Tile from "../../components/Tile/Tile";
import ComplexChart from "../../components/ComplexChart/ComplexChart";
import TileLegend from "../../components/TileLegend/TileLegend";
import SecondaryHeading from "../../components/SecondaryHeading/SecondaryHeading";
import FoodSourceEvents from "../../components/FoodSourceEvents/FoodSourceEvents";

function SectionWhat({ foodTypeConsumedData, atHomeEventsData, awayFromHomeEventsData }) {
    return (
        <div className="details-chart">
            <PrimaryHeading>
                <HeadingGradient>What</HeadingGradient>
                <span>what consumers<br/>decided to eat</span>
            </PrimaryHeading>
            <Tile>
                <ComplexChart
                    title={(
                        <>
                            Food Type Consumed{/* <TileLegend />*/}
                        </>
                    )}
                    columnsConfig={[
                        [1, 2],
                        [3, 4],
                        [5],
                    ]}
                    categories={foodTypeConsumedData}
                />
            </Tile>
            <Tile>
                <SecondaryHeading>
                    At home events
                </SecondaryHeading>
                <div className="food-source-events-wrap">
                    <FoodSourceEvents
                        data={atHomeEventsData[0]}
                        color='green'
                    />
                    <FoodSourceEvents
                        data={atHomeEventsData[1]}
                        color='blue'
                    />
                </div>
            </Tile>
            <Tile>
                <SecondaryHeading>
                    Away from home events
                </SecondaryHeading>
                <div className="food-source-events-wrap">
                    <FoodSourceEvents
                        data={awayFromHomeEventsData[0]}
                        color='green'
                    />
                    <FoodSourceEvents
                        data={awayFromHomeEventsData[1]}
                        color='blue'
                    />
                </div>
            </Tile>
        </div>
    );
}

export default SectionWhat;